import script from "./CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"

import "./CompletedCoursesModal.vue?vue&type=style&index=0&id=15796f16&lang=css"

const __exports__ = script;

export default __exports__